<script setup lang="ts">
import { Toaster } from './sonner'

defineOptions({
  name: 'FaToast',
})
</script>

<template>
  <Toaster position="top-center" />
</template>
